<template>
  <div
    id="addon-gkmg-port-master-destination-work-list"
    v-if="hasAddonGkmgPortMaster"
  >
    <div class="flex pm-destination-work-top">
      <div class="flex w-1/2 justify-start">
        <img :src="leftArrow" class="left-arrow" @click="moveDate(-1)" />
        <div class="display-date">
          <span class="pm-current-time">{{ dispDate }}</span>
        </div>
        <img :src="rightArrow" class="right-arrow" @click="moveDate(1)" />
      </div>
      <div class="flex w-1/2 justify-end">
        <div
          class="flex justify-start pm-filter-control"
          style="color: #bdbdbd"
        >
          <span>
            <span class="last-updated-text"
              >最終更新 ： {{ lastUpdatedTime }}</span
            >
          </span>
        </div>
        <!-- 現在新規作成ボタン -->
        <div
          v-if="canEditWorkList"
          class="flex justify-start pm-filter-control"
          style="color: #bdbdbd"
        >
          <button class="button-add-row" @click="showNewTaskDialog">
            <span>＋ 新規登録</span>
          </button>
        </div>

        <div
          class="flex justify-start pm-filter-control pm-cursor-pointer"
          @mousedown="reconnectToServer"
          :style="{ color: onReconnect ? '#828282' : '#bdbdbd' }"
        >
          <span class="icon-reload-display">
            <feather-icon
              icon="RefreshCwIcon"
              svgClasses="h-4 w-4"
              style="margin: 0 0.2rem"
            />
            <span>画面再読込み</span>
          </span>
        </div>
        <div
          class="flex justify-end pm-cursor-pointer"
          @mousedown="onChangeActiveListFlg"
        >
          <div
            style="
              padding: 0.3rem 2.6rem 0.3rem 0.2rem;
              background-color: #4f4f4f;
              margin: 0 0 0.5rem 0.5rem;
              border-radius: 0.2rem;
            "
          >
            <div v-if="activeListFlg">
              <img
                :src="finishedCheckIconUrl"
                style="
                  width: 1rem;
                  height: 1rem;
                  margin: 0 0.6rem;
                  padding-top: 0.2rem;
                "
              />
              <span style="color: #f2f2f2">終了</span>
            </div>
            <div v-else>
              <img
                :src="finishedBackIconUrl"
                style="
                  width: 1rem;
                  height: 1rem;
                  margin: 0 0.6rem;
                  padding-top: 0.2rem;
                "
              />
              <span style="color: #f2f2f2">戻る</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      @click="helpUpdateFilterStateChangeWhenClickedOutSideTheFilterComponent"
    >
      <ag-grid-vue
        ref="agGridTable"
        :rowData="destinationWorkTasks"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :components="components"
        rowSelection="multiple"
        colResizeDefault="shift"
        :floatingFilter="false"
        :enableRtl="$vs.rtl"
        :rowDragManaged="true"
        :animateRows="false"
        :suppressHorizontalScroll="true"
        :suppressDragLeaveHidesColumns="true"
        @grid-size-changed="onGridSizeChangedFromAgGrid"
        class="ag-theme-material ag-grid-table"
        :class="[
          isReadOnlyDevice === true ? 'pm-ag-grid-vue-ipad-width' : null,
        ]"
        @dragStopped="onDragStopped"
      >
      </ag-grid-vue>

      <cell-summary-dialog
        :showPopup.sync="showPopupSync"
        :clickX="clickX"
        :clickY="clickY"
        :popupTitle="popupTitle"
        :popupTaskId="popupTaskId"
        :popupTask="popupTask"
        :popupColumnKey="popupColumnKey"
        :popupValueMap="popupValueMap"
        @updateGridCell="updateGridCell"
        :canEdit="canEditWorkList"
        :vesselsData="vesselsData"
      />
      <!-- 削除ダイアログ -->
      <delete-task-dialog
        v-if="canEditWorkList"
        :popupActive="isActiveDeletePopup"
        @close="onCancel"
        @cancel="onCancel"
        @delete="onDelete"
      />
      <!-- 新規作成ダイアログ -->
      <new-task-dialog
        v-if="canEditWorkList"
        :popupActive="isActiveNewPopup"
        :vesselsData="vesselsData"
        @close="closeNewTaskDialog"
        @cancel="closeNewTaskDialog"
        @create="onCreate"
      />
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moment from "moment-timezone";
import CellRendererItem from "./components/CellRendererItem";
import CellRendererTrash from "./components/CellRendererTrash";
import CellSummaryDialog from "./components/CellSummaryDialog";
import DeleteTaskDialog from "./components/DeleteTaskDialog";
import NewTaskDialog from "./components/NewTaskDialog.vue";
import { AgGridVue } from "ag-grid-vue";
import authService from "@/services/authService";
import _ from "lodash";
import { DeviceInfoMixin } from "@/mixins";
import { COL_NAME } from "@/config/const.js";
import FireStoreService from "@/services/fireStoreService";
// フィルター用コンポーネント
import FilterSelect from "@/components/molecules/gkmg-port-master/FilterSelect";
import CustomHeader from "@/components/organisms/gkmg-port-master/CustomHeader";
import { isSameTaskVesselNameAndMasterVesselName } from "@/utils/gkmgPortMaster";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState, mapGetters } = createNamespacedHelpers(
  "gkmgPortMasterDestinationWork",
);
const {
  mapState: mapStateOfGkmgPortMaster,
  mapGetters: mapGetterOfGkmgPortMaster,
  mapActions: mapActionOfGkmgPortMaster,
} = createNamespacedHelpers("gkmgPortMaster");

export default {
  name: "O.DestinationWorkList",
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererItem,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererTrash,
    CellSummaryDialog,
    DeleteTaskDialog, // 削除ダイアログ
    NewTaskDialog, // 新規作成ダイアログ
    /*
     * フィルター用コンポーネント
     * <filter-select/>のようにtemplateに埋め込むのではなくsetColumnDefsのfilterに渡す形で使用しているため、
     * 宣言しているのに使われていない旨のeslintエラーが出てしまう。
     * エラーを消すために//esling-disable-next-lineコメントを入れている。
     */
    // eslint-disable-next-line
    FilterSelect,
    // eslint-disable-next-line
    CustomHeader,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      isReady: false,
      pageLoadTime: 0,
      dispDate: "",
      destinationWorkTasks: [],
      grabbedRowIndex: null,

      clickX: -1,
      clickY: -1,
      popupTitle: "",
      popupTaskId: "",
      popupColumnKey: "",
      popupValueMap: {},
      onReconnect: false,
      isReadOnlyDevice: false,

      // AgGrid-common
      components: { CellRendererItem },
      defaultColDef: {
        sortable: false,
        resizable: false,
        filter: true,
      },

      // AgGrid
      gridApi: null,
      columnDefs: [],
      gridOptions: {
        localeText: { noRowsToShow: "船舶が見つかりませんでした" },
        context: { componentParent: this },
        suppressCellSelection: true,
        onRowDragMove: this.onRowDragMove,
        onRowDragEnd: this.onRowDragEnd,
        onCellMouseDown: this.onCellClicked,
        suppressMoveWhenRowDragging: true,
        rowBuffer: 125,
        onFirstDataRendered() {
          window.dispatchEvent(new Event("resize"));
        },
      },
      popupBlackList: [],

      // カラム名と、そのカラムのfirestoreでのドキュメントID
      columnNameDocIdMap: {},

      leftArrow: require("@/assets/images/icons/gkmg-port-master/left_arrow.svg"),
      rightArrow: require("@/assets/images/icons/gkmg-port-master/right_arrow.svg"),

      activeListFlg: true,
      finishedCheckIconUrl: require("@/assets/images/icons/port-master/finished_check.svg"),
      finishedBackIconUrl: require("@/assets/images/icons/port-master/finished_back.svg"),
      isActiveDeletePopup: false, // 削除ダイアログ表示フラグ
      isActiveNewPopup: false, // 新規作成ダイアログ表示フラグ
    };
  },
  watch: {
    vesselsData() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.reflectVesselMasterChanges();
          this.isReady = true;
          this.pageLoadTime = moment().valueOf();
          this.$vs.loading.close();
        }, 1200);
      });
    },
    lastUpdatedForTasks() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.redrawGrid();
          this.isReady = true;
          this.pageLoadTime = moment().valueOf();
          this.$vs.loading.close();
        }, 1200);
      });
    },
    lastUpdatedForMasters() {
      if (this.isReady) {
        this.redrawGrid();
      }
    },
    onChangeWindowSize() {
      this.onGridSizeChanged();
    },
  },
  computed: {
    ...mapState({
      destinationWorkTasksMap: (state) => state.destinationWorkTasksMap,
      lastUpdatedForTasks: (state) => state.lastUpdatedForTasks,
      lastUpdatedForMasters: (state) => state.lastUpdatedForMasters,
      displayDates: (state) => state.displayDates,
      selectedTaskId: (state) => state.selectedTaskId,
      selectedColumnKey: (state) => state.selectedColumnKey,
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
      masterMap: (state) => state.masterMap,
    }),
    ...mapGetters({
      selectedDateFormatted: "selectedDateFormatted",
      selectedDate: "selectedDate",
      presentColumnsFilteringState: "presentColumnsFilteringState",
      lastUpdatedTime: "lastUpdatedTime",
      filterRuleMerged: "filterRuleMerged",
    }),
    ...mapStateOfGkmgPortMaster({
      selectedPort: (state) => state.selectedPort,
      vesselsData: (state) => state.vesselsData,
    }),
    ...mapGetterOfGkmgPortMaster([
      "gkmgPortMasterAuth",
      "hasAddonGkmgPortMaster",
      "vesselsDataMap",
    ]),
    showPopupSync: {
      get() {
        return this.summaryDialogShowPopup;
      },
      set(val) {
        this.setSummaryDialogShowPopup(val);
      },
    },
    // ag-gridにフィルターコンポーネントを渡すかを指定するためのMap
    applyFilterComponentMap() {
      const map = COL_NAME.reduce((acc, col) => {
        if (col && col.columnKey) {
          acc[col.columnKey] = col.filterable;
        }
        return acc;
      }, {});
      return map;
    },
    destinationWorkTasksSelectedDate() {
      const { selectedDate, destinationWorkTasksMap } = this;
      if (!_.isString(selectedDate)) return {};
      if (!destinationWorkTasksMap) return {};
      return destinationWorkTasksMap[selectedDate.replaceAll("/", "")] || {};
    },
    popupTask() {
      const { destinationWorkTasksSelectedDate, popupTaskId } = this;
      if (!_.isObject(destinationWorkTasksSelectedDate)) return {};
      if (!(_.isString(popupTaskId) && popupTaskId.length > 0)) return {};
      return this.destinationWorkTasksSelectedDate[popupTaskId] || {};
    },
    canEditWorkList() {
      return this.gkmgPortMasterAuth.destinationWorkList.edit;
    },
    orderDate() {
      const movedDate = moment(this.selectedDate, "YYYY/MM/DD");
      return movedDate.toDate();
    },
    // 画面で表示する進捗の状態に応じて返すタスクのリストが変わる
    // 進捗が終了を表示する場合: 終了したタスク
    // 進捗が終了でないものを表示する場合: 終了でないタスク
    dispTaskList() {
      let dispTaskList = [];
      const destinationWorkTasks =
        this.destinationWorkTasksMap[this.selectedDate.replaceAll("/", "")];
      if (destinationWorkTasks) {
        for (let taskId of Object.keys(destinationWorkTasks)) {
          let dispTask = destinationWorkTasks[taskId];

          let isTarget =
            !dispTask.progress ||
            !dispTask.progress.valueMap ||
            !dispTask.progress.valueMap.itSelf
              ? false
              : this.activeListFlg // true: 終了でないタスク, false: 終了したタスク
              ? dispTask.progress.valueMap.itSelf !== 3
              : dispTask.progress.valueMap.itSelf === 3;

          if (isTarget) {
            dispTaskList.push(Object.assign({}, dispTask, { id: taskId }));
          }
        }
      }
      return dispTaskList;
    },
    // dispTaskListをフィルターしたものを返す
    filteredDispTaskList() {
      const filteredDispTaskList = this.filterTask(
        this.dispTaskList,
        this.filterRuleMerged,
      );
      return filteredDispTaskList;
    },
  },
  methods: {
    showNewTaskDialog() {
      this.isActiveNewPopup = true;
    },
    ...mapActions([
      "subscribeDestinationWorkTasks",
      "saveTaskWithName",
      "updateFirestoreDocument",
      "unsubscribeFirestore",
      "setTargetDates",
      "mergeUpdateDataIntoTaskRecord",
      "setSummaryDialogShowPopup",
      "setSelectedDate",
      "updateStoredFilterRule",
      "resetStoredFilterRule",
      "setPresentColumnsFilteringState",
      "resetPresentColumnsFilteringState",
      "deleteDestinationWorkOneTask",
      "createDestinationWorkTask",
    ]),
    ...mapActionOfGkmgPortMaster([
      "searchVessels",
      "unsubscribeFirestoreOnVesselMaster",
      "getGkmgPortMasterAuth",
    ]),
    /**
     * 入出港予定一覧表のフィルター機能で使う、セレクトオプションを取得する。
     * @param {*} columnKey : フィルターを行うカラムのキー。
     */
    getSelectOptions(columnKey) {
      const selectedDate = this.selectedDate.replaceAll("/", "");
      if (!this.destinationWorkTasksMap[selectedDate]) return [];

      const selectedDateTasks = this.destinationWorkTasksMap[selectedDate];
      const options = Object.entries(selectedDateTasks)
        .filter(([key, value]) => {
          if (!key) return false;
          if (!_.isObject(value[columnKey])) return false;
          if (!_.isObject(value[columnKey].valueMap)) return false;
          const valueItSelf = value[columnKey].valueMap.itSelf;
          return valueItSelf !== undefined && valueItSelf !== null; // 値がないものをフィルタリング
        })
        .map((el) => {
          // gkmg_pm_settingsでマスタ管理している項目の場合
          if (columnKey === "island_id") {
            // 島でフィルターをかけるときは、島/港をまとめてせんたくできるようにする。
            const islandId = el[1].island_id.valueMap.itSelf;
            const islandLabel = this.masterMap.islands.find(
              (el) => String(el.id) === String(islandId),
            ).label;
            const portId = el[1].island_id.valueMap.portId;
            const portLabel = this.masterMap.ports.find(
              (el) => String(el.id) === String(portId),
            ).label;
            return {
              value: `${portId}`, // 島は港から導くので、実質港によるフィルターとなる
              label: `${islandLabel}/${portLabel}`,
            };
          }
        });
      // セレクトオプションのうち重複した値は一つに絞る。またフィルター中の値はも除外する。
      const uniqOptionMap = options.reduce((map, option) => {
        map[option.value] = option;
        return map;
      }, {});

      const uniqOptions = Object.keys(uniqOptionMap).map(
        (key) => uniqOptionMap[key],
      );

      const sortedOptions = uniqOptions.toSorted((a, b) => {
        return Number(a.value) - Number(b.value);
      });

      return sortedOptions;
    },
    /**
     * FilterSelect.vueから呼び出して使用する関数。
     * フィルター機能を操作した時に、storeのstoredFilterRuleとpresentColumnsFilteringStateを更新する。
     */
    updateFilterRule(filterKey, keyword, isFilterExclude) {
      const filterRule = {
        [filterKey]: {
          [keyword]: !isFilterExclude,
        },
      };

      this.updateStoredFilterRule(filterRule);

      this.redrawGrid();
    },
    updateFilterState(columnKey, isHovered, isSelected) {
      /**
       * filter時のデザイン制御のために、カラムごとのフィルター状態を、storeに保存する
       */
      const dispTasks =
        this.destinationWorkTasksMap[this.selectedDate.replaceAll("/", "")];

      if (!dispTasks) return;

      const isFiltered =
        this.dispTaskList.length !== this.filteredDispTaskList.length;

      let hoverSelectedState = "";
      if (!isHovered && !isSelected) {
        hoverSelectedState = "default";
      } else if (isHovered && !isSelected) {
        hoverSelectedState = "hover";
      } else {
        // !isHovered && isSlect の場合と isHovered && isSelectの場合
        hoverSelectedState = "select";
      }

      const filterState = isFiltered
        ? `filtered/${hoverSelectedState}`
        : hoverSelectedState;

      const presentColumnsFilteringState = Object.assign(
        {},
        this.presentColumnsFilteringState,
      );

      // 操作した列の状態を変更する。
      presentColumnsFilteringState[columnKey] = filterState;

      // 操作した列以外の状態を変更する。
      Object.entries(presentColumnsFilteringState).forEach((el) => {
        if (
          el[0] !== columnKey &&
          ["filter/hover", "hover", "filter/select", "select"].includes(el[1])
        ) {
          /*
           * filter/hoverとhover : filter/default又はdefaultに変換
           * filter/selectとselect : filter/default又はdefaultに変換
           */
          presentColumnsFilteringState[el[0]] = el[1]
            .replace("hover", "default")
            .replace("select", "default");
        }
      });

      this.setPresentColumnsFilteringState(presentColumnsFilteringState);
    },
    /**
     * FilterSelectのfilterRow()を呼び出すのみでは、フィルタを行ったときのデザインの仕様を満たすことができないため、filterRow関数では処理しきれない処理を助ける形で実行する。
     * できれば処理を分けずに書きたいが、現状、フィルターコンポーネントの外側をクリックした時の挙動は以下の関数に別立てで記載している。
     */
    helpUpdateFilterStateChangeWhenClickedOutSideTheFilterComponent() {
      const presentColumnsFilteringState = Object.assign(
        {},
        this.presentColumnsFilteringState,
      );
      Object.entries(presentColumnsFilteringState).forEach((el) => {
        presentColumnsFilteringState[el[0]] = el[1].replace(
          "select",
          "default",
        );
      });
      this.setPresentColumnsFilteringState(presentColumnsFilteringState);
    },
    /*
     * 入出港予定一覧表の行(タスク)をフィルターするための関数。
     * 現状はport_idによるフィルタのみ
     */
    filterTask(
      dispTaskList, // destinationWorkTasks[`${'YYYY/MM/DD'}`]
      filterRule, // filterの設定オブジェクト
    ) {
      if (!Array.isArray(dispTaskList)) return [];
      if (!_.isObject(filterRule)) return dispTaskList;

      const filteredTasks = dispTaskList.filter((task) => {
        const { docData } = task;
        const { port_id: portId } = docData;
        if (_.isNil(portId)) return true; // portを持たないものは表示する

        return filterRule.port_id[portId];
      });
      return filteredTasks;
    },
    redrawGrid() {
      const sortedDestinationWorkTasks = _.orderBy(
        this.filteredDispTaskList,
        [
          // 第1ソート: sort_order
          (task) => {
            return _.isNumber(task.sort_order.valueMap.itSelf)
              ? task.sort_order.valueMap.itSelf
              : Number.MAX_SAFE_INTEGER;
          },
          // 第2ソート: オーダー時間
          (task) => {
            return task.order_time.valueMap.itSelf;
          },
          "id", // 第3ソート: id
        ],
        ["asc", "asc", "asc"],
      );

      this.setDestinationWorkTasks(
        this.gridOptions.api,
        sortedDestinationWorkTasks,
      );

      // grid1 データ表示リロード
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true, suppressFlash: true });
        this.$nextTick(() => {
          this.onGridSizeChanged();
        });
      }
    },
    /**
     * 日付を移動する
     * days：動く日数 -1で1日戻る、1で1日進む
     */
    moveDate(days) {
      moment.locale("ja");
      const movedDate = moment(this.selectedDate)
        .add(days, "days")
        .format("YYYY/MM/DD");

      if (!this.displayDates.includes(movedDate)) {
        return;
      }

      this.setSelectedDate(movedDate);
      this.resetStoredFilterRule();
      this.resetPresentColumnsFilteringState();

      this.redrawGrid();
    },
    /**
     * 列ドラッグ後のイベント
     */
    onDragStopped(e) {
      const gkmgPortMasterColumns =
        e.columnApi.getAllGridColumns().map((x) => {
          return {
            docId: this.columnNameDocIdMap[x.colId],
            columnName: x.colId,
          };
        }) || [];
      FireStoreService.setGkmgDestinationWorkListColumnsSortOrder(
        gkmgPortMasterColumns,
      );
    },
    setDestinationWorkTasks(gridOptionsApi, newDestinationWorkTasks) {
      let lastIndex = -1;
      let removeNode = [];
      gridOptionsApi.forEachNode((rowNode, index) => {
        if (newDestinationWorkTasks[index]) {
          // update
          // rowNode.setData(newDestinationWorkTasks[index]);

          // agGridとstateのvalueMapを比較して、変化を検知した時だけupdate
          let valudMapDiffList = [];
          for (let key of Object.keys(rowNode.data)) {
            if (!["docData"].includes(key)) {
              if (
                rowNode.data[key].valueMap &&
                newDestinationWorkTasks[index][key].valueMap
              ) {
                const taskJsonAtGrid = JSON.stringify(
                  this.objectSort(rowNode.data[key].valueMap),
                );
                const taskJsonAtState = JSON.stringify(
                  this.objectSort(newDestinationWorkTasks[index][key].valueMap),
                );
                if (taskJsonAtGrid !== taskJsonAtState) {
                  valudMapDiffList.push(key);
                }
              } else if (
                rowNode.data[key].valueMap === undefined &&
                newDestinationWorkTasks[index][key].valueMap
              ) {
                valudMapDiffList.push(key);
              } else if (
                rowNode.data[key].valueMap &&
                newDestinationWorkTasks[index][key].valueMap === undefined
              ) {
                valudMapDiffList.push(key);
              }
            }
          }

          if (valudMapDiffList.filter((x) => !!x).length > 0) {
            // update
            rowNode.setData(
              JSON.parse(JSON.stringify(newDestinationWorkTasks[index])),
            );
          }
          lastIndex = index;
        } else {
          // prepare delete
          removeNode.push(rowNode.data);
        }
      });
      if (removeNode.length > 0) {
        gridOptionsApi.applyTransaction({ remove: removeNode });
      }
      if (lastIndex + 1 < newDestinationWorkTasks.length) {
        // insert
        gridOptionsApi.applyTransaction({
          add: JSON.parse(
            JSON.stringify(newDestinationWorkTasks.slice(lastIndex + 1)),
          ),
        });
      }
    },
    objectSort(obj) {
      // ソートする
      const entries =
        typeof obj === "object" && obj !== null ? Object.entries(obj) : [obj];
      const sorted = entries.sort();

      for (let i in sorted) {
        if (Array.isArray(sorted[i]) && sorted[i][0] !== "task_detail") {
          const val = sorted[i][1];
          if (typeof val === "object") {
            // valueを調べ、objectならsorted entriesに変換する
            sorted[i][1] = this.objectSort(val);
          }
        }
      }

      return sorted.filter((x) => !!x && !!x[1]);
    },
    async updateGridCell(updateData) {
      const payload = {
        updateData: updateData,
        vesselsData: this.vesselsData,
      };
      const newTaskWithName = await this.mergeUpdateDataIntoTaskRecord(payload);

      // agGrid1の対象行に直接更新。
      const updatedTaskId = updateData.taskId ? updateData.taskId : null;
      if (!updatedTaskId) {
        return;
      }
      this.gridOptions.api.forEachNode((rowNode, _) => {
        const taskId = rowNode.data.taskId.valueMap.itSelf
          ? rowNode.data.taskId.valueMap.itSelf
          : null;
        if (taskId === updatedTaskId) {
          rowNode.setData(newTaskWithName);
        }
      });
    },
    onRowDragMove: function (evt) {
      if (this.grabbedRowIndex == null) {
        // ドラッグイベント開始時のみ行番号を記憶
        this.grabbedRowIndex = evt.overIndex;
      }
    },
    onRowDragEnd: function (evt) {
      if (this.grabbedRowIndex == evt.overIndex) {
        // onRowDragMoveで記憶したドラッグイベント開始時の行番号と同じなら、何もしない。
        return;
      }
      this.grabbedRowIndex = null;

      // ag-grid-vueの行入れ替えのイベント
      const sortOrderDataList = this.$refs.agGridTable
        .getRowData()
        .map((rowData, index) => {
          return {
            taskId: Object.values(rowData).find((x) => x.taskId).taskId,
            enterprisePort: this.selectedPort,
            data: { sort_order: index },
          };
        });

      sortOrderDataList.forEach((sortOrderData) => {
        sortOrderData.enterprisePort = this.selectedPort;
        this.updateFirestoreDocument(sortOrderData);
      });
    },

    onTrashClicked(
      evt, // Event
    ) {
      this.popupTaskId = evt.data.order_time.taskId; // order_timeは必ず存在するため、そこからtaskIdを取得
      this.showPopupSync = false;
      this.isActiveDeletePopup = true;
    },

    onCancel() {
      this.popupTaskId = "";
      this.isActiveDeletePopup = false;
    },

    closeNewTaskDialog() {
      this.popupTaskId = "";
      this.isActiveNewPopup = false;
    },

    async onDelete() {
      try {
        this.$vs.loading();
        await this.deleteDestinationWorkOneTask({ id: this.popupTaskId }); // タスクを削除
        this.popupTaskId = "";
        this.isActiveDeletePopup = false;
      } catch {
        this.$vs.notify({
          title: "削除に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
          position: "top-center",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    createNewTaskData(
      evt, //   {vesselId: string; vesselName: undefined; orderHours: number; orderMinutes: number}
      //      | {vesselId: undefined; vesselName: string; orderHours: number; orderMinutes: number}
    ) {
      const {
        vesselId = null,
        vesselName = null,
        orderHours,
        orderMinutes,
      } = evt;
      const { orderDate, vesselsDataMap } = this;

      const orderTime = new Date(orderDate);
      orderTime.setHours(orderHours);
      orderTime.setMinutes(orderMinutes);
      const newTaskVesselName = vesselsDataMap[vesselId]
        ? vesselsDataMap[vesselId].data.name
        : vesselName;
      return {
        vessel_id: vesselId,
        vessel_name: newTaskVesselName,
        order_time: orderTime,
        progress: 1,
      };
    },

    async onCreate(
      evt, //   {vesselId: string; vesselName: undefined; orderHours: number; orderMinutes: number; progress: 1}
      //      | {vesselId: undefined; vesselName: string; orderHours: number; orderMinutes: number; progress: 1}
    ) {
      try {
        this.$vs.loading();
        const newTaskData = this.createNewTaskData(evt);
        await this.createDestinationWorkTask(newTaskData); // タスクを作成
        this.isActiveNewPopup = false;
      } catch {
        this.$vs.notify({
          title: "新規作成に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
          position: "top-center",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    canClickNameColumn(
      taskData, // destinationWorkTasksMap[date][taskId]( {docData: {vessel_name: string} | undefined} )
    ) {
      const { canEditWorkList, vesselsDataMap } = this;
      if (canEditWorkList) return true;

      if (!_.isObject(taskData)) return false;
      if (!taskData.docData) return false;
      if (!taskData.docData.vessel_id) return false;
      const vesselId = taskData.docData.vessel_id;
      const vesselsMaster = vesselsDataMap[vesselId];
      return isSameTaskVesselNameAndMasterVesselName(taskData, vesselsMaster); // 編集権限がある か 船舶名がマスタと同じ時だけクリック可能
    },

    onCellClicked: function (evt) {
      // ゴミ箱ボタンクリック時の動作
      if (evt.colDef.field === "trash") {
        this.onTrashClicked(evt);
        return;
      }
      const columnKey = evt.value.columnKey;

      // 船舶名クリック時の動作
      if (columnKey === "name") {
        const { data: taskData } = evt;
        // 船舶名選択時は、編集権限がなく かつ 船舶名がマスタと異なる時は何もしない
        if (!this.canClickNameColumn(taskData)) return;
      }

      /*
       * セルがクリックされたら、vs-popupを起動
       * １）firestoreから取得した権限を参照し、編集権限がない場合は何もしない。
       * ２）ポップアップ表示する列項目について、編集不可の項目の場合は何もしない。
       * ３）上記１，２の例外として、船舶名がクリックされた場合
       *    1. 船舶名が船舶マスタとタスクで一致する場合
       *       a. 編集権限あり -> ポップアップを表示
       *       b. 編集権限なし -> ポップアップを表示
       *    2. 一致しない場合
       *       a. 編集権限あり -> ポップアップを表示(名前変更のみ)
       *       b. 編集権限なし -> ポップアップ非表示
       */

      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずdestinationWorkList.editを持つ

      // 編集権限
      if (
        !this.gkmgPortMasterAuth.destinationWorkList.edit &&
        columnKey !== "name"
      ) {
        return;
      }

      // マスタの編集権限の有無（const.jsのCOL_NAMEでeditableがfalseならばポップアップを表示しない)
      if (this.popupBlackList.includes(columnKey) && columnKey !== "name") {
        return;
      }

      this.popupTitle = this.createPopupTitle(columnKey);
      this.popupTaskId = evt.value.taskId;
      this.popupColumnKey = columnKey;
      if (["from_anchorage_time", "to_anchorage_time"].includes(columnKey)) {
        evt.value.valueMap["selectedDate"] = this.selectedDate;
      }

      this.popupValueMap = evt.value.valueMap;

      this.clickX = evt.event.clientX;
      this.clickY = evt.event.clientY;

      this.showPopupSync = true;
    },
    createPopupTitle(columnKey) {
      const workHeader = COL_NAME.find(
        (header) => header.columnKey === columnKey,
      );
      if (workHeader.displayType === "masterMap") return "島/港/岸壁/バース";
      return workHeader && workHeader.columnKey !== "name"
        ? workHeader.name
        : "";
    },
    bindGridApi() {
      // 以下は、ag-grid-vueが実体化されたあとにセットする必要がある。v-show, v-ifで注意。
      this.gridApi = this.gridOptions.api;
    },

    onGridSizeChangedFromAgGrid() {
      const prepareSec = 8; // ag-gridからの onGridSizeChanged() 呼び出しはページロード後 prepareSec秒まで。
      if (
        this.pageLoadTime > 0 &&
        this.pageLoadTime + prepareSec * 1000 > moment().valueOf()
      ) {
        this.onGridSizeChangedFromAgGridDebounce(this);
      }
    },
    onGridSizeChangedFromAgGridDebounce: _.debounce((self) => {
      self.onGridSizeChanged();
    }, 3000),

    onGridSizeChanged() {
      let paramObjList = [];
      let paramObj = {
        gridApi: this.gridApi,
        gridElement: this.$refs.agGridTable.$el,
      };
      paramObjList.push(paramObj);

      // figmaより、60px
      const ROW_HEIGHT = 60;

      for (let paramObj of paramObjList) {
        // agGridVueのHeader部分の座標サイズを取得
        const agHeaderViewport = paramObj.gridElement.querySelector(
          ".ag-header-viewport",
        );
        let agHeaderRect = agHeaderViewport.getBoundingClientRect();
        const clientHeight = document.documentElement.clientHeight;
        const pmAgGridHeight = clientHeight - agHeaderRect.top + 1; // agGrid全体の高さ
        paramObj.gridElement.style.height = pmAgGridHeight + "px";

        const agCenterContainer = paramObj.gridElement.querySelector(
          ".ag-center-cols-clipper",
        );

        if (agCenterContainer) {
          // スクロール時は、body内側の height も再計算
          this.$nextTick(() => {
            const rowCount = paramObj.gridApi.getDisplayedRowCount();
            agCenterContainer.style.height = ROW_HEIGHT * (rowCount + 1) + "px";
          });
        }
        paramObj.gridApi.forEachNode(function (rowNode) {
          rowNode.setRowHeight(ROW_HEIGHT);
        });
        paramObj.gridApi.onRowHeightChanged();
        // 再描画
        paramObj.gridApi.sizeColumnsToFit();
      }
    },

    async reconnectToServer() {
      // fireStoreのセッションが切れたと思われた場合に再接続するメソッド

      this.$vs.loading();
      this.onReconnect = true;

      // idトークンリフレッシュ。
      await authService
        .renewToken() // 既存のIDトークンが生きている場合は何もしない。
        .then(() => {
          return authService.getIdToken();
        })
        .then((t) => {
          this.$store.commit("SET_ID_TOKEN", { idToken: t });
        });

      // firestoreリッスンを再接続
      await this.unsubscribeFirestore();
      await this.subscribeDestinationWorkTasks(this.vesselsData);

      this.$nextTick(() => {
        setTimeout(() => {
          this.onReconnect = false;
          this.$vs.loading.close();
        }, 3000);
      });
    },
    detectReadOnlyDevice() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (
        userAgent.indexOf("ipad") > -1 ||
        (userAgent.indexOf("macintosh") > -1 && "ontouchend" in document)
      ) {
        // iPadの場合
        this.isReadOnlyDevice = true;
      }
    },
    calcCellRenderer(
      columnDef, // columnDefs[index]
    ) {
      const defaultRenderer = "CellRendererItem";
      if (!_.isObject(columnDef)) return defaultRenderer;
      if (columnDef.columnKey === "trash") return "CellRendererTrash";
      return defaultRenderer;
    },
    setColumnDefs(columnDefs) {
      const columnNamesMap = _.mapKeys(COL_NAME, "columnKey");
      this.columnDefs = columnDefs.map((header) => {
        let cellClassNameList = ["pm-ag-grid-cell"];
        const isSuppressed = !COL_NAME.find(
          (col) => col.columnKey === header.columnKey,
        ).sortable;
        if (header.columnKey === "sort_order") {
          cellClassNameList = ["pm-ag-row-drag"];
        }
        if (
          this.isReadOnlyDevice === true &&
          !["caution_note", "vessel"].includes(header.columnKey)
        ) {
          cellClassNameList.push("pm-ag-grid-cell-readonly");
        }

        const columnSetting = columnNamesMap[header.columnKey];
        const filterable = columnSetting.filterable;
        const filterKey = columnSetting.filterKey;
        return {
          field: header.columnKey,
          rowDrag: header.columnKey === "sort_order" ? true : false,
          headerName: ["sort_order", "highlight"].includes(header.columnKey)
            ? ""
            : header.name,
          headerComponentFramework: "CustomHeader",
          width: header.width,
          minWidth:
            COL_NAME.find((el) => el.columnKey === header.columnKey).minWidth ||
            null,
          resizable: true,
          suppressMovable: isSuppressed,
          lockPosition: isSuppressed ? "left" : undefined,
          cellRenderer: this.calcCellRenderer(header),
          cellClass: cellClassNameList.join(" "),
          cellRendererParams: { displayNumber: 1 },
          cellClassRules: {
            "pm-highlight": (params) =>
              params.node.data.highlight.valueMap.itSelf == 1,
          },
          filter: this.applyFilterComponent(header.columnKey),
          filterable,
          filterKey,
        };
      });
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },
    async getLastColumnsSortOrder() {
      const accountSettings =
        await FireStoreService.getGkmgDestinationWorkListColumnsSortOrder();

      // 列の並び順を入れ替えたときにfirestoreの設定を更新できるように、カラム名ごとのドキュメントIDを保存しておく。
      accountSettings.forEach(
        (el) => (this.columnNameDocIdMap[el.column_name] = el.document_id),
      );

      /*
       * １）初回に表示させる列項目は、管理画面から手動等でfirestoreに登録される。(ただし、sort_orderとhighlightについては、管理画面からの入力対象外)。
       * ２）sort_orderとhighlightはフロント側で、列の左側に固定で表示させる（sort_orderが一番左、その右隣がhighlight）。
       * ３）列項目が取得出来ない場合は、何も表示させない。(管理画面から表示対象列が入力されていない場合は、何も表示させるべきではない)
       * ４）二回目以降は、ユーザーが前回まで表示していたカラム表示順番（列左右の表示順）についても取得し、画面の表示に反映させる。
       * ５）sortOrderedColumnDefs(前回の列並び順）には含まれるが、COL_NAMEに含まれない列項目は、createdの中で、firebaseから削除させている。
       */

      const fixPositionColumns = this.gkmgPortMasterAuth.destinationWorkList
        .edit
        ? ["trash", "sort_order", "highlight"]
        : [];
      const fixPositionColumnList = COL_NAME.filter((el) =>
        fixPositionColumns.includes(el.columnKey),
      );
      const allColumnsNameList = COL_NAME.filter(
        (el) => !["trash", "sort_order", "highlight"].includes(el.columnKey),
      ).map((el) => el.columnKey);

      const sortOrderedColumnDefs = accountSettings
        .sort((a, b) => {
          return Number(a.sort_order) - Number(b.sort_order);
        })
        .map((el) => COL_NAME.find((col) => col.columnKey === el.column_name))
        .filter((el) => allColumnsNameList.includes(el.columnKey));

      if (sortOrderedColumnDefs.length === 0) {
        return;
      }
      this.setColumnDefs(fixPositionColumnList.concat(sortOrderedColumnDefs));
    },
    /**
     * 列名に応じたフィルターコンポーネントを適用する。
     */
    applyFilterComponent(columnKey) {
      return this.applyFilterComponentMap[columnKey] ? "FilterSelect" : "";
    },
    reflectVesselMasterChanges() {
      const destinationWorkTask =
        this.destinationWorkTasksMap[this.selectedDate.replaceAll("/", "")];

      // 表示するデータが存在しない時はこの後の整形処理は不要なのでreturnする
      if (!destinationWorkTask) {
        return;
      }

      Object.entries(destinationWorkTask).forEach((taskObj) => {
        const vesselsMaster = this.vesselsData.find(
          (el) => el.data.id === taskObj[1].vessel_id.valueMap.itSelf,
        );
        const payload = {
          date: this.selectedDate.replaceAll("/", ""),
          taskId: taskObj[0],
          docData: taskObj[1].docData,
          vesselsMaster: vesselsMaster,
        };
        this.saveTaskWithName(payload);
      });
    },
    onChangeActiveListFlg() {
      this.$vs.loading();
      setTimeout(() => {
        this.activeListFlg = !this.activeListFlg;
        this.redrawGrid();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 1000);
        });
      }, 2000);
    },
  },
  async created() {
    if (!this.hasAddonGkmgPortMaster) return;
    // 編集画面を起動しないカラム名を格納するリスト(onCellClicked関数で使用する)
    this.popupBlackList = COL_NAME.filter((el) => {
      return !el.editable;
    }).map((el) => String(el.columnKey));

    this.detectReadOnlyDevice();

    // 予定表の日付
    const ORDER_LIST_DATE = {
      BEFORE_DAYS: 2, // 何日前
      AFTER_DAYS: 2, // 何日後
    };
    await this.setTargetDates(ORDER_LIST_DATE);

    // Firestore監視開始
    await this.searchVessels();
    await this.subscribeDestinationWorkTasks(this.vesselsData);

    await FireStoreService.deleteUnnecessaryColumnsSortOrder(
      COL_NAME.map((el) => el.columnKey),
    );
    this.getLastColumnsSortOrder();
  },
  async mounted() {
    if (!this.hasAddonGkmgPortMaster) return;
    this.$vs.loading();

    this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "portMaster");
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.padding = "0.0rem";

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container",
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }

    // 左上の現在時刻表示
    moment.locale("ja");
    setInterval(() => {
      this.dispDate = this.selectedDateFormatted;
    }, 300);

    this.bindGridApi();

    document.body.oncontextmenu = function () {
      return false;
    };

    let self = this;
    window.onresize = function () {
      self.gridApi.sizeColumnsToFit();
    };
    // templateの外にあるクラスにスタイルを付与する
    this.$nextTick(() => {
      document.body.classList.add("gkmg-work-list-body");
    });
    await this.getGkmgPortMasterAuth();
  },
  beforeDestroy() {
    // call unsubscribe .
    this.unsubscribeFirestore();
    this.unsubscribeFirestoreOnVesselMaster();
    // templateの外にあるクラスにスタイルを削除する
    document.body.classList.remove("gkmg-work-list-body");
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
html,
body {
  &:has(> #addon-gkmg-port-master-destination-work-list) {
    font-family: $pm-font-family;
  }
  &.gkmg-work-list-body {
    .v-nav-menu-swipe-area {
      display: none;
    }
    .ag-dnd-ghost {
      display: none;
    }
  }
}

#addon-gkmg-port-master-destination-work-list {
  background-color: $pm-black;
  min-height: calc(100vh - 0px);

  // ag-grid-vue のヘッダ部分
  .ag-theme-material .ag-header-cell,
  .ag-theme-material .ag-header-group-cell {
    font-size: 12px;
    color: $pm-light-gray;
    padding: 0 0 0 0;
  }

  .ag-icon-menu {
    background-size: contain;
    background-repeat: no-repeat;
    color: transparent;
  }
  .ag-theme-material .ag-row {
    background-color: black !important;
  }

  .updated-cell,
  .pm-grouped-row {
    height: 100%;
  }
  .ag-row-drag {
    height: 100%;
  }

  .ag-theme-material {
    font-family: $pm-font-family;
    font-size: inherit !important;
  }

  .pm-ag-grid-vue {
    padding-bottom: 0px;
  }
  .pm-ag-grid-vue-div2 {
    padding-left: 4px;
    padding-right: 4px;
  }
  .pm-ag-grid-vue-ipad-width {
    padding-left: 0px;
    padding-right: 0px;
  }
  .pm-ag-grid-cell {
    padding: 0 !important;
    margin: 0 auto;
    color: $pm-white;
    background-color: #333333;
    text-align: left;
    border: none !important;
  }
  .pm-ag-grid-cell-readonly {
    pointer-events: none;
  }
  .pm-ag-row-drag {
    @extend .pm-ag-grid-cell;
    height: 100%;
    div {
      height: 100%;
      padding-top: 0.15rem;
      margin: 0 0.2rem 0 auto !important;
    }
  }

  .pm-highlight {
    background-color: #65676a;
    border-top: 0.1rem solid #333333 !important;
  }

  .pm-highlight > div {
    width: 100%;
    background-color: #65676a;
    margin: 0 !important;
  }

  .last-updated-text {
    margin-left: auto;
    font-size: 15px;
    line-height: 30px;
    align-items: center;
  }

  .icon-reload-display {
    font-size: 15px;
    line-height: 30px;
    align-items: center;
  }

  .pm-destination-work-top {
    margin-bottom: 1rem;
    width: 100%;
  }

  .pm-current-time {
    margin: 0.5rem 1.5rem 0 0.8rem;
    color: $pm-white;
    font-size: 120%;
  }
  .pm-display-date {
    border-radius: 1rem;
    padding: 0 1.5rem 0 1rem;
    margin-top: 0.4rem;
  }

  .pm-display-date-popup {
    .pm-display-date-item {
      margin: 0.2rem;
    }
    .vs-popup {
      width: 40rem;
      background-color: $pm-white !important;
    }
    header {
      h3 {
        text-align: center;
        background-color: $pm-white;
      }
      i {
        border-radius: 2rem;
        border: 0.15rem solid $pm-black;
        font-weight: bold;
      }
      background-color: $pm-white;
    }
    .outer-area {
      padding: 1rem;
    }
    .save-button {
      margin: 0 1rem;
      width: 30%;
    }
    .vs-popup--close {
      background-color: $pm-white !important;
      transform: translate(-10px, 10px);
      &:hover {
        transform: translate(-10px, 8px);
      }
    }
  }

  .pm-filter-control {
    padding: 0.3rem 0.7rem;
    color: $pm-dark-blue-navy;
  }

  .ag-header-viewport {
    background-color: $pm-black;
  }
  .ag-center-cols-viewport {
    background-color: $pm-black;
    overflow-x: hidden;
  }
  .ag-body-viewport {
    min-height: 100%;
    overflow-y: overlay !important;
    background-color: $pm-black;
  }
  .ag-header {
    min-height: 2rem !important;
    --ag-header-cell-hover-background-color: #4f4f4f;
  }
  .ag-header-row {
    height: 2rem !important;
    font-family: $pm-font-family;
    font-size: inherit !important;
  }
  .ag-header-cell-label {
    background-color: $pm-black;
  }
  .ag-header-cell-label:hover {
    background-color: #4f4f4f;
  }
  .ag-header-cell-resize {
    background-color: $pm-black;
  }
  .ag-row .ag-cell {
    display: flex;
    align-items: center;
    border-top: 0.05rem solid #4f4f4f !important;
  }
  .ag-theme-material .ag-row {
    border: 0.03rem solid #000000; // 行間罫線
  }

  .ag-theme-material .ag-cell {
    line-height: 1rem;
  }

  .pm-cursor-pointer {
    cursor: pointer;
  }

  /** 矢印ボタン用のCSS */
  .left-arrow {
    width: 24px;
    height: 24px;
    background: #4f4f4f;
    border-radius: 6px;
    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin-top: 7px;
    margin-left: 5px;
    color: #bdbdbd;
    font-weight: bold;
    &::after {
      /* Vector */
      position: absolute;
      left: 37.5%;
      right: 37.5%;
      top: 25%;
      bottom: 25%;
      border: 1.11458px solid #bdbdbd;
    }
    &:hover {
      cursor: pointer;
    }
  }

  .right-arrow {
    width: 24px;
    height: 24px;
    background: #4f4f4f;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 2;
    flex-grow: 0;
    margin-top: 7px;
    color: #bdbdbd;
    font-weight: bold;
    &::after {
      /* Vector */
      position: absolute;
      left: 37.5%;
      right: 37.5%;
      top: 25%;
      bottom: 25%;
      border: 1.11458px solid #bdbdbd;
    }
    &:hover {
      cursor: pointer;
    }
  }

  .button-add-row {
    width: 130px;
    height: 30px;
    font-family: "Hiragino Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    /* identical to box height */
    display: flex;
    align-items: center;
    color: #bdbdbd;
    background-color: #000000;
    /* Inside auto layout */
    flex: none;
    flex-grow: 0;
    padding-left: 10px;
    /** border */
    border-radius: 5px;
    border: 1px solid #626262;
    &:hover {
      cursor: pointer;
    }
  }

  .display-date {
    font-family: "Hiragino Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    /* ボックスの高さと同一 */
    display: flex;
    align-items: center;

    color: #bdbdbd;

    /* オートレイアウト内部 */
    flex: none;
    order: 0;
    flex-grow: 0;
  }
}
</style>
